export const HexRegExp = new RegExp(/^#([0-9a-f]{6}|[0-9a-f]{3})$/);
export const JustNumbersAndLettersRegExp = new RegExp(/[^A-Za-z0-9Ññ]/);
export const NoNumbersRegExp = new RegExp(/([A-Za-zñ<> äÄëËïÏöÖüÜáÁéÉíÍóÓúÚýÝ'¿"#_-Ä-´°%;&¨Ñ,¡.*+?^=!:$(){}|[\]\/\\])/);
export const SpecialCharsRegExp = new RegExp(/([<> äÄëËïÏöÖüÜáÁéÉíÍóÓúÚýÝ'¿"#´°%;&¨,¡.*+?^=!:$(){}|[\]\/\\])/);
export const UrlRegExp = new RegExp(/^((http[s]?|ftp):\/)?\/?([^:\/\s]+)((\/\w+)*\/)([\w\-\.]+[^#?\s]+)(.*)?(#[\w\-]+)?$/);
export const emailIsValid = (value, expression) => Boolean(value.match(expression));
export const hexIsValid = (value) => HexRegExp.test(value);
export const urlIsValid = (value) => UrlRegExp.test(value);
export const hasJustNumbersAndLetters = (value) => !JustNumbersAndLettersRegExp.test(value);
export const hasNoNumbers = (value) => NoNumbersRegExp.test(value);
export const hasSpecialChars = (value) => SpecialCharsRegExp.test(value);
export const replaceSpecialChars = (value, newValue) => value.replace(SpecialCharsRegExp, newValue);
